// extracted by mini-css-extract-plugin
export default {"container":"CodeContent_container__IX0jd"};